import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import DateFormatter from 'DateFormatter';
import Tags from '@Components/Tags';
import Thumbnail from '@Components/Thumbnail';

function ArticleListItem({ articleData }) {
  const tags = [...articleData.categories || [], ...articleData.tags || []];
  const route = useRouteMatch();
  const articleDate = DateFormatter(articleData.date, 'd M Y');

  return (
    <li className="blog-overview__item">
      <article className="blog-overview__article">
        <Thumbnail articleData={articleData} />
        <div className="blog-overview__content">
          <a href={articleData.url} className="blog-overview__link">
            <span className="blog-overview__date">{articleDate}</span>
            {/* Client request to support html tags inside. */}
            {/* eslint-disable-next-line react/no-danger, xss/no-mixed-html */}
            <span className="blog-overview__title" dangerouslySetInnerHTML={{ __html: articleData.field_title }} />
          </a>
          <Tags path={route.path} tags={tags} />
        </div>
      </article>
    </li>
  );
}

export default injectIntl(ArticleListItem);
